import { useEffect, useState } from 'react';

export const LoadingModal = ({
  isActive,
  onClose,
  brandLogo,
  loadingFailed
}) => {
  const [dots, setDots] = useState('');

  useEffect(() => {
    if (!isActive) return;

    const interval = setInterval(() => {
      setDots((prev) => {
        if (prev === '...') return '';
        return prev + '.';
      });
    }, 500);

    return () => clearInterval(interval);
  }, [isActive]);

  if (!isActive) return null;

  return (
    <div className={`loading-vu-modal ${isActive ? 'active' : ''}`}>
      <div className="loading-container">
        <button
          className="close-loading no-bg mobile-hidden"
          onClick={onClose}
          aria-label="Close"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.5 1.5L22.5 22.5M22.5 1.5L1.5 22.5" stroke="black" strokeWidth="2" strokeLinecap="round" />
          </svg>
        </button>
        <div className="position-absolute-center flex-column-center">
          {brandLogo && (
            <div className="brand-logo-loading">
              <img
                src={brandLogo}
                alt="brand logo"
                width={120}
                height={120}
                style={{ height: 'auto' }}
              />
            </div>
          )}
          <div className="loading-gif">
            <svg viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg">
              <circle
                cx="25"
                cy="25"
                r="20"
                stroke="#000"
                strokeWidth="5"
                fill="none"
                strokeDasharray="94.2477796077"
                strokeDashoffset="47.1238898038"
              />
            </svg>
          </div>
          {loadingFailed && (
            <div className={`vu-failed-loading ${loadingFailed ? 'active' : ''}`}>
              <p>Loading failed. Please refresh the page or try again later.</p>
            </div>
          )}
          <strong className="loading-assets">
            Loading assets
            <span>{dots}</span>
          </strong>
        </div>
        <div className="loading-bottom-text position-absolute-bottom">
          This may take a moment depending on your internet connection
        </div>
      </div>
    </div>
  );
};
